import styled, { css } from "styled-components";

export const Header = styled.h1`
  color: var(--primary-dark);
  font-family: Rubik;
  font-size: 1rem;
  line-height: 20px;
  font-style: normal;
  font-weight: 500;
  margin: 0;
  word-wrap: break-word;
  white-space: normal;
`;

export const ToggleBox = styled.div`
  position: relative;
  width: 100%;
  height: 12px;
  border-radius: 12px;
  background-color: var(--primary-dark-100);
  cursor: pointer;
  user-select: none;
`;

export const SectionDivider = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 1px;
  background-color: var(--primary-dark-50);
  left: ${({ left }) => left};
`;

export const TogglerCircle = styled.div`
  position: absolute;
  top: 50%;
  left: ${({ left }) => left};
  width: 9px;
  height: 9px;
  background-color: var(--primary-blue);
  border-radius: 50%;
  transform: translateY(-50%) translateX(-50%);
  transition: all 150ms ease;
  cursor: grab;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);

  ${({ $isDragging }) =>
    $isDragging &&
    css`
      cursor: grabbing;
      transform: translateY(-50%) translateX(-50%) scale(1.1);
      box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
    `}
`;

export const Screen = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  min-width: 100px;
  width: ${({ width }) => width};

  ${Header} {
    min-width: 100px;
    width: ${({ width }) => width};
  }

  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      ${ToggleBox} {
        cursor: default;
      }

      ${TogglerCircle} {
        cursor: default;
        background-color: var(--primary-dark-200);
      }

      ${Header} {
        color: var(--primary-dark-200);
      }
    `}
`;
